import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireDatabase, AngularFireList} from '@angular/fire/database'
import { User } from './../../model/users';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private dbPath ='/Users';
  userRef: AngularFireList<User> =null;
  constructor(public db: AngularFirestore, private db1: AngularFireDatabase) { 
    this.userRef = db1.list(this.dbPath)
  }
  //For Creating a new task
  createTask(value) {
    return this.db.collection('todo').add({
      task: value,
      completed: false,
      nameToSearch: value.toLowerCase()
    });
  }

  //Display complete list of task
  getTasks() {
    return this.db.collection('todo').snapshotChanges();
  }

  //For deleting particular task
  deleteTask(taskKey) {
    return this.db.collection('todo').doc(taskKey).delete();
  }

  //For updating particular task
  updateTask(taskKey, value) {
    return this.db.collection('todo').doc(taskKey).set(
      {
        task: value.task,
        completed: value.completed,
        nameToSearch: value.nameToSearch
      }
    )
  }
  createUser(user:User){
    this.userRef.push(user)
  }

  getUserlist(): AngularFireList<User> {
    // console.log(User,"User------------------")
    return this.userRef;

  }
  markAll(action) {
    this.db.collection('todo').get().forEach((item) => {
      return item.docs.map(m => {
        return this.db.doc(`todo/${m.id}`).update({ completed: action });
      });
    });
  }

}
